define('views/shared/button/success_modal',[
    'views/_base/baseview',
    'text!views/shared/button/success_modal.html'
], function (BaseView, Template){
    'use strict';

    return BaseView.extend({
        id      : 'button-success-modal-container',
        tagName : 'div',
        isRender: true,
        template: _.template(Template),
        events  : {
            'click .js-button-success-modal-btn': 'successConfirmationMODAL',
            'click #pf-modal-close-btn'         : 'closeMODAL',
            'click .js-button-cancel-modal-btn' : 'cancelMODAL'
        },
        initialize: function(options){
            options = options || {};

            this.dataMODAL = options.data;
            this.calling_view_MODAL = options.calling_view;

            this.elementName = options.elementName;

            BaseView.prototype.initialize(this);
        },

        render: function(){
            var that = this;

            this.$el.html(this.template());

            return this;
        },

        loadData: function(){},

        successConfirmationMODAL: function(){
            
            this.closeMODAL();

        },

        cancelMODAL: function(e){
            if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });

            if(_.isFunction(this.dataMODAL.btn_cancel_modal_callback)){
                
                if(this.dataMODAL.btn_cancel_modal_callback.name){
                    this.calling_view_MODAL[this.dataMODAL.btn_cancel_modal_callback.name]();
                } else {
                    this.dataMODAL.btn_cancel_modal_callback(this.calling_view_MODAL);
                }
                
            }

        },

        closeMODAL: function(){
            this.calling_view_MODAL.successModalCallbackMODAL();

            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

